import React from 'react';

const StyleMatcherResults: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <h1 className="text-2xl font-serif text-gray-900">Style Matcher Results</h1>
      <p className="text-gray-500 mt-4">Results page coming soon...</p>
    </div>
  );
};

export default StyleMatcherResults;